import ZtConfirmDialogComponent from './index.vue';
import {isVNode, createApp} from 'vue';
import installElementUI from '../../lib/element-polyfill';

const noop = () => {};

const defaultOptions = {
    title: '',
    okText: '确认',
    cancelText: '取消',
    onOk: noop,
    message: '',
    onCancel: noop
};

/***
 * 警告确认框
 * @param {Object} options 配置项
 */
export function ztConfirmDialog(options) {
    let confirmDialogInstance;
    let currentApp = null;
    let confirmDialogProps = {};
    let currentConfig = {};
    options = Object.assign({}, defaultOptions, options);
    const body = document.body;
    const wrapper = document.createElement('div');
    body.append(wrapper);
    function close() {
        currentConfig = {
            ...currentConfig,
            visible: false
        };
        update(currentConfig);
    }
    function update(newConfig) {
        currentConfig = {
            ...currentConfig,
            ...newConfig,
        };
        confirmDialogInstance && Object.assign(confirmDialogInstance, { confirmDialogProps: currentConfig });
    }

    currentConfig = {
        title: options.title || undefined,
        okText: options.okText || undefined,
        cancelText: options.cancelText || undefined,
        message: options.message,
        onCancel: function () {
            typeof options.onCancel === 'function' && options.onCancel();
            close();
            setTimeout(() => {
                currentApp && currentApp.unmount();
                body.removeChild(wrapper);
            }, 1000);
        },
        onOk: function (cb) {
            typeof options.onOk === 'function' && options.onOk(cb);
        },
        visible: true
    };
    
    function render(props) {
        confirmDialogProps = props;
        const app = createApp({
            data() {
                return { confirmDialogProps, vIf: true };
            },
            render() {
                // 先解构，避免报错，原因不详
                const cdProps = { ...this.confirmDialogProps };
                const slots = {}
                if (isVNode(cdProps.message)) {
                    slots.default = function () {
                        return cdProps.message;
                    };
                }
                return this.vIf ? <ZtConfirmDialogComponent {...cdProps}>
                    {slots}
                </ZtConfirmDialogComponent> : null
            }
        });
        installElementUI(app);
        currentApp = app;
        return app.mount(wrapper);
    }

    confirmDialogInstance = render(currentConfig);
}

